'use client';

import { ShieldCheck } from 'lucide-react';

interface EoCompleteModalProps {
  onFinish: () => void;
}

export function EoCompleteModal({ onFinish }: EoCompleteModalProps) {
  return (
    <div
      className="fixed inset-0 z-[300] flex items-center justify-center"
      role="dialog"
      aria-modal="true"
      aria-label="E&O Guardrails tour complete"
    >
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/50" />

      {/* Modal card */}
      <div className="relative bg-white rounded-2xl shadow-2xl max-w-lg w-full mx-4 p-8">
        {/* Icon */}
        <div className="mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-full bg-accent-blue/[0.08]">
          <ShieldCheck className="h-8 w-8 text-accent-blue" />
        </div>

        {/* Title */}
        <h2 className="text-2xl font-bold mb-4 text-center text-gray-900">
          Your Agency Is Protected
        </h2>

        {/* Content */}
        <div className="text-left space-y-4 mb-8">
          <p className="text-base leading-relaxed text-gray-500">
            E&amp;O Guardrails are <strong className="text-gray-700">always active</strong> for
            every message sent through Voley. Your team gets real-time guidance while you get the
            peace of mind that risky language is being caught.
          </p>
          <div className="bg-gray-50 rounded-lg p-4 space-y-2">
            <p className="text-sm text-gray-600">
              <strong className="text-gray-900">Remember:</strong> Guardrails are a safety net,
              not a cage. They flag potential risks so your team can make informed decisions &mdash;
              every message is still sent by a human who understands the client relationship.
            </p>
          </div>
          <p className="text-sm leading-relaxed text-gray-500">
            Encourage your team to use client notes to share important context. The more context
            everyone has, the fewer E&amp;O risks you&rsquo;ll face.
          </p>
        </div>

        {/* Finish button */}
        <div className="flex justify-center">
          <button
            onClick={onFinish}
            aria-label="Finish tour"
            className="inline-flex items-center justify-center gap-2 px-8 py-3 rounded-full text-base font-semibold text-white bg-accent-blue hover:brightness-110 transition-all shadow-md"
          >
            Finish Tour
          </button>
        </div>
      </div>
    </div>
  );
}
